export default __webpack_public_path__ + "static/media/services_heading.c99924a6.png";